module.exports = __webpack_public_path__ + "img/bg-image-6.a3de0614.jpg";